(() => {
  const root = document.querySelector('[data-product]');
  if (!root) return;
  const json = document.getElementById('ProductJson');
  const product = json ? JSON.parse(json.textContent) : null;
  const idInput = root.querySelector('input[name="id"]');
  const img = document.getElementById('ProductImage');

  document.querySelectorAll('.js-thumb').forEach((btn) => {
    btn.addEventListener('click', () => { if (img) img.src = btn.dataset.src; });
  });

  const qty = root.querySelector('input[name="quantity"]');
  const syncTcgQty = () => {
    const link = document.querySelector('[data-tcg-cart]');
    if (!link || link.dataset.tcgMode !== 'cart' || !link.dataset.tcgVariant) return;
    const n = Math.max(1, Number(qty?.value || 1));
    const store = (link.dataset.tcgStore || 'https://tcgplayer.com.lc').replace(/\/$/, '');
    const coupon = (link.dataset.tcgCoupon || 'VENTORA15').trim().toUpperCase();
    const redirect = `/cart/add?id=${encodeURIComponent(link.dataset.tcgVariant)}&quantity=${n}&return_to=/cart`;
    link.href = `${store}/discount/${encodeURIComponent(coupon)}?redirect=${encodeURIComponent(redirect)}`;
  };
  root.querySelector('.js-qty-minus')?.addEventListener('click', () => {
    qty.value = Math.max(1, Number(qty.value) - 1);
    syncTcgQty();
  });
  root.querySelector('.js-qty-plus')?.addEventListener('click', () => {
    qty.value = Number(qty.value) + 1;
    syncTcgQty();
  });
  qty?.addEventListener('change', syncTcgQty);

  const selects = [...root.querySelectorAll('.js-option')];
  const matchVariant = () => {
    if (!product) return;
    const values = selects.map((s) => s.value);
    const variant = product.variants.find((v) => values.every((val, i) => v.options[i] === val));
    if (variant && idInput) idInput.value = variant.id;
  };
  selects.forEach((s) => s.addEventListener('change', matchVariant));

  const recs = document.querySelector('[id^="shopify-section-"] .grid-products');
  if (product?.id) {
    fetch(`/recommendations/products?product_id=${product.id}&limit=4&section_id=recs`)
      .catch(() => {});
  }

  img?.addEventListener('click', () => {
    img.requestFullscreen?.();
  });
})();
